import React from "react"

import { BanknotesIcon, UserGroupIcon } from "@heroicons/react/24/solid"

import { Color } from "~tailwindui/types/enums"

import { path } from "~Tutor/TutorRoutes"
import ActionList from "~Tutor/components/ActionList"

export type ToDoProps = {
  viewer: {
    id: string
    calendarId: string
    unbilledSessions: {
      data: {
        id: string
      }[]
    }
    groupsNeedingScheduling: {
      data: {
        id: string
      }[]
    }
  }
}

const ToDo: React.FC<ToDoProps> = ({ viewer }) => {
  return (
    <ActionList
      title="To Do"
      color={Color.Red}
      hideOnEmpty
      warning
      listItems={[
        viewer.unbilledSessions.data.length > 0 && {
          icon: BanknotesIcon,
          path: path("unbilledSessionsIndex"),
          text: `Bill Recent Sessions (${viewer.unbilledSessions.data.length})`,
          active: true,
        },
        viewer.groupsNeedingScheduling.data.length > 0 && {
          icon: UserGroupIcon,
          path: path("studyGroupsIndexNeedingScheduling"),
          text: `Schedule Sessions for new Study Groups (${viewer.groupsNeedingScheduling.data.length})`,
        },
      ]}
    />
  )
}

export default ToDo
